import { computed } from 'mobx';

/**
 * Project model for View
 */
class HrAssignReqTimeLineGroupModel {
  id: number;
  title: string;
  stackItems: boolean;
  constructor(obj: any) {
    this.id = obj.id;
    this.title = obj.title;
    this.stackItems = obj.stackItems;
  }
}
export default HrAssignReqTimeLineGroupModel;
